import React from 'react'
import rete from '../img/Vector.svg'

export default function Rate() {
  return (
    <div className='rate'>
        <div className='rate-mark'>
            <span>5.0</span>
        </div>
        <span className='rate-desc'>Trusted by 500+ Companies</span>
    </div>
  )
}
